import { EntityType } from '@texas/api/endpoints/trackerApi';

export interface TrackerConfigProps {
  canTrack: EntityType[];
}

export const trackerConfig: Record<EntityType, TrackerConfigProps | undefined> =
  {
    [EntityType.Customer]: {
      canTrack: [EntityType.Sample, EntityType.Inquiry, EntityType.Offer],
    },
    [EntityType.Sample]: undefined,
    [EntityType.ProductApproval]: undefined,
    [EntityType.CompositionGroup]: undefined,
    [EntityType.Variant]: undefined,
    [EntityType.Article]: undefined,
    [EntityType.Concept]: undefined,
    [EntityType.Supplier]: {
      canTrack: [EntityType.Inquiry],
    },
    [EntityType.Inquiry]: undefined,
    [EntityType.Offer]: undefined,
  };
